import ADD_PRODUCT_MAIN_CATEGORY from 'api/mutations/ADD_PRODUCT_MAIN_CATEGORY';
import REMOVE_PRODUCT_MAIN_CATEGORY from 'api/mutations/REMOVE_PRODUCT_MAIN_CATEGORY';
import UPDATE_PRODUCT_MAIN_CATEGORY from 'api/mutations/UPDATE_PRODUCT_MAIN_CATEGORY';
import GET_PRODUCT_MAIN_CATEGORIES from 'api/queries/GET_PRODUCT_MAIN_CATEGORIES';
import { createProductParameterSlice } from './createProductParameterSlice';
const productMainCategoriesSlice = createProductParameterSlice({
    name: 'productMainCategories',
    stateKey: 'productMainCategories',
    query: GET_PRODUCT_MAIN_CATEGORIES,
    addMutation: ADD_PRODUCT_MAIN_CATEGORY,
    updateMutation: UPDATE_PRODUCT_MAIN_CATEGORY,
    removeMutation: REMOVE_PRODUCT_MAIN_CATEGORY,
    idVariableName: 'productMainCategoryId',
    selectConnection: (data) => data.autocomplete.productMainCategories,
    selectAddedItem: (data) => data.addProductMainCategory.productMainCategory,
    selectUpdatedItem: (data) => data.updateProductMainCategory.productMainCategory,
});
export const resetProductMainCategories = productMainCategoriesSlice.reset;
export const fetchProductMainCategories = productMainCategoriesSlice.fetchItems;
export const addProductMainCategory = productMainCategoriesSlice.addItem;
export const updateProductMainCategory = productMainCategoriesSlice.updateItem;
export const removeProductMainCategory = productMainCategoriesSlice.removeItem;
export const selectProductMainCategories = productMainCategoriesSlice.selectItems;
export const selectProductMainCategoryById = productMainCategoriesSlice.selectItemById;
export const selectProductMainCategoriesPageInfo = productMainCategoriesSlice.selectPageInfo;
export const selectProductMainCategoriesStatus = productMainCategoriesSlice.selectStatus;
export const selectProductMainCategoriesErrors = productMainCategoriesSlice.selectErrors;
export const selectProductMainCategoriesRefetchFlags = productMainCategoriesSlice.selectRefetchFlags;
export default productMainCategoriesSlice.reducer;
